import _ from 'lodash'

import { SelectItem } from '@spa/components/atoms/model/SelectItem'
import { log } from '../../../../log'
import { CancelCode } from '../../../../services/api/orderHistory'

export class CancelReason {
  static get list(): SelectItem[] {
    return [
      {
        // Title option
        value: '',
        text: 'キャンセル理由',
        selected: true,
        disabled: true,
      },
      {
        value: CancelCode.DUPLICATE,
        text: '同じものを２回注文してしまった',
      },
      {
        value: CancelCode.RETRY,
        text: '決済がうまく行かず、何度か注文されていた',
      },
      {
        value: CancelCode.OPERATION_ERROR,
        text: '操作ミス',
      },
      {
        value: CancelCode.ORDER_MISTAKEN,
        text: '注文内容を間違った（数量、住所など）',
      },
      {
        value: CancelCode.OTHER,
        text: 'その他',
      },
    ]
  }

  static getText(code: CancelCode | null): string | null {
    const option = _.find(this.list, ['value', code])

    if (!option) {
      log.error('Invalid cancel code.')

      return null
    }

    return option.text
  }
}
